function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.239 24.198c-.066.08-.137.159-.215.233l-.922.88c-.961.916-2.525.92-3.488.002L.721 17.785a2.276 2.276 0 01.003-3.327l.922-.88c.961-.916 2.525-.92 3.487-.002l5.209 4.968L24.863 4.693c.967-.922 2.53-.924 3.494-.004l.922.88c.963.918.961 2.412-.004 3.332L13.24 24.198z",
  fill: "currentColor"
})));